import { usePlanStore } from "../../../../../store/PlanStore";

import { ReactComponent as WaterMeterSVG } from "../../../../../assets/water-meter.svg";
import ElementWrapper from "../common/ElementWrapper";

function WaterMeter({
  id,
  x,
  y,
}: {
  id: number | string;
  x: number;
  y: number;
}) {
  return (
    <ElementWrapper id={id} x={x} y={y} size={20}>
      <WaterMeterSVG width={20} height={20} />
    </ElementWrapper>
  );
}

function WaterMeterElements() {
  const { data } = usePlanStore();

  const waterTaps =
    data?.elements.filter(
      (e) => e.type === "system-element" && e.systemType === "water-meter"
    ) ?? [];

  if (waterTaps.length === 0) return null;

  return (
    <>
      {waterTaps.map((waterTap) => (
        <WaterMeter
          key={waterTap.id}
          id={waterTap.id}
          x={waterTap.x}
          y={waterTap.y}
        />
      ))}
    </>
  );
}

export default WaterMeterElements;
